
<template>
    <div class="join-info">
<div class="section-content">

    <div class="topTab flex">
        <div class="green item1"><img class="img" src="https://sk-ims-cabinet.sikegroup.com/image/jpg/yesC.png"> 基本信息</div>
        <div> <img src="https://sk-ims-cabinet.sikegroup.com/image/jpg/right.png" /></div>
        <div class="item2"><span v-show="bool">2 </span><img class="img" v-show="!bool" src="https://sk-ims-cabinet.sikegroup.com/image/jpg/yesC.png">提交申请</div>
        <div><img src="https://sk-ims-cabinet.sikegroup.com/image/jpg/right.png" /></div>
        <div><span>3 </span> 资质审核</div>
    </div>
    <form>
        <div class="content" v-if="bool">
            <div class="fontTitle title">1. 基本信息</div>

            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="minTitle">姓名 <sup>*</sup></div>
                    <input type="text" name="Name" minlength="2" maxlength="40" v-model="Name" placeholder="请输入">
                </div>
                <div>
                    <div class="minTitle">个人信息 <sup>*</sup></div>
                    <div class="flex">
                        <div class="area mTop flex">
                            <div class="color" style=" line-height: 30px;">性别 </div>
                            <div style="position: relative;">
                                <div class="radios" style="margin-right: 10px;">
                                    <input type="radio" id="sex1" v-model="radioSex" name="Sex" value="1">
                                    <label for="sex1"></label>
                                    <span>男</span>
                                </div>
                                <div class="radios">
                                    <input type="radio" id="sex2" v-model="radioSex" name="Sex" value="0">
                                    <label for="sex2"></label>
                                    <span>女</span>
                                </div>
                            </div>
                        </div>
                        <div class="area flex">
                            <span class="lineHeight color">婚 姻 </span>
                            <select class="select sel" name="type" v-model="Marriage">
                                <option value="请选择">请选择</option>
                                <option value="未婚">未婚</option>
                                <option value="已婚">已婚</option>
                                <option value="离异">离异</option>
                            </select>
                            <img class="icon" src="https://sk-ims-cabinet.sikegroup.com/image/jpg/right.png" />
                        </div>
                        <div class="area flex">
                            <span class="lineHeight color"> 籍 贯 </span>
                            <select class="select sel" name="province" v-model="NativePlace">
                                <option v-for="(item,i) in ProvinceArr" :key="i" :value="item.Id">{{item.Name}}</option>
                            </select>
                            <img class="icon" src="https://sk-ims-cabinet.sikegroup.com/image/jpg/right.png" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="minTitle">出生日期 <sup>*</sup></div>
                    <!-- <input type="text" name="BrithDay" maxlength="10" placeholder="如:1992-01-07"/> -->
                     <el-date-picker
                    v-model="BrithDay"
                    type="date"
                    style="width: 500px;"
                    value-format="yyyy-MM-dd"
                    placeholder="选择出生日期">
                    </el-date-picker>
                    <!-- <input type="text" name="Birthday" class="" v-model="BrithDay" placeholder="如：2018-06-21" /> -->
                </div>
                <div>
                    <div class="minTitle">联系方式</div>
                    <div class="flex">
                        <div class="area flex">
                            <span> 手机号码 <sup>*</sup> </span>
                            <input type="text" name="Mobile" v-model="Mobile" onkeyup="value=value.replace(/[^\d]/g,'')" maxlength="11" />
                        </div>
                        <div class="area flex">
                            <span> 固定电话 </span>
                            <input type="text" name="Tel" v-model="Tel" maxlength="12" placeholder="如：0000-0000000" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="minTitle">电子邮件 <sup>*</sup></div>
                    <input type="text" name="Email" v-model="Email" placeholder="请输入邮箱">
                </div>
                <div>
                    <div class="minTitle">联系时间<span class="orange">（早上9点后或者下午、非工作时间）</span></div>
                    <input type="text" name="DateT" v-model="DateT" placeholder="请输入联系时间" maxlength="19">
                </div>
            </div>

            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="minTitle">家庭住址 </div>
                    <input type="text" name="HomeAddress" v-model="HomeAddress" placeholder="请输入住址">
                </div>
                <div>
                    <div class="minTitle">户籍地址</div>
                    <input type="text" name="Address" v-model="Address" placeholder="请输入户籍地址">
                </div>
            </div>

            <div class="fontTitle flex mbottom-1">
                <!-- <div>
                    <div class="minTitle">家庭年收入 <sup>*</sup></div>
                    <input type="email" name="email" placeholder="请输入">
                </div> -->
                <div>
                    <div class="minTitle">受供养人数 <sup>*</sup></div>
                    <input style="width:47.5%" type="text" name="BringUp" v-model='BringUp' placeholder="包括儿女、父母" />
                </div>
            </div>

            <div class="fontTitle flex mbottom-1-1"  id="spouse">
                <div>
                    <div class="minTitle">配偶信息 </div>
                    <div class="flex">
                        <div class="area flex">
                            <span class="width_9"> 配偶姓名<sup class="hidden">*</sup> </span>
                            <input type="text" name="MateName" v-model='MateName' />
                        </div>
                        <div class="area flex">
                            <span class="width_6"> 职业<sup class="hidden">*</sup> </span>
                            <input type="text" name="MateProfession" v-model='MateProfession' />
                        </div>
                    </div>
                </div>
                <div>
                    <div class="minTitle"></div>
                    <div class="flex">
                        <div class="area flex">
                            <span class="width_6"> 职务<sup class="hidden">*</sup>  </span>
                            <input type="text" name="MatePosition" v-model='MatePosition' />
                        </div>
                    </div>
                </div>
            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="flex">
                        <div class="area flex">
                            <span class="width_6"> 手机 </span>
                            <input type="text" name="MateMobile" v-model="MateMobile" onkeyup="value=value.replace(/[^\d]/g,'')" maxlength="11" />
                        </div>
                        <div class="area flex">
                            <span class="width_6"> 教育 </span>
                            <input type="text" name="MateEdu" v-model='MateEdu' />
                        </div>
                    </div>
                </div>
                <div>

                    <div class="flex">
                        <div class="area flex">
                            <span class="width_9"> 电子邮件 </span>
                            <input type="email" name="MateEmail" v-model="MateEmail"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 2  education教育-->
            <div class="fontTitle education">
                2. 教育背景
                <p class="area mTop">以下信息是关于您的教育背景的信息，烦请详细列出您所接受过的正式教育和其他相关培训、是否有职称或获得过什么荣誉等信息</p>
            </div>

            <div class="fontTitle flex mbottom-1">
                <div style="width:700px;">
                    <div class="area flex" >
                        <span class="width_6"> 学校 <sup>*</sup> </span>
                        <input type="text" name="School_1" v-model="School_1" class=" " />
                    </div>
                </div>
                <div>
                    <div class="flex">
                        <div class="area flex" >
                            <span> 毕业时间 <sup>*</sup> </span>
                              <el-date-picker
                             v-model="GraduationTime_1"
                            type="monthrange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            value-format="yyyy-MM - yyyy-MM"
                            end-placeholder="结束日期">
                            </el-date-picker>
                            <!-- <input type="text" name="GraduationTime_1" class=" " id="GraduationTime_1" placeholder="如：2013-08 - 2016-06" /> -->
                        </div>
                        <div class="area flex">
                            <span class="width_6"> 学历<sup>*</sup> </span>
                            <input type="text" name="Education" v-model="Education" placeholder="请填写最高学历" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="textareaTitle">其他培训经历</div>
                    <textarea name="Train" v-model='Train' placeholder="谈谈您参与过的培训经历"></textarea>
                </div>

            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="area flex">
                        <span class="width_6"> 职称 </span>
                        <input type="text" name="Title" v-model="Title" />
                    </div>
                </div>
                <div>
                    <div class="flex">
                        <div class="area flex">
                            <span> 获得时间</span>
                            <!-- <input type="text" name="DateTime_1" v-model="DateTime_1" class=" " id="DateTime_1" placeholder="如：2018-06-21" /> -->
                            <el-date-picker
                            v-model="DateTime_1"
                            type="date"
                             value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                            </el-date-picker>
                        </div>
                        <div class="area flex">
                            <span> 颁发机构 </span>
                            <input type="text" name="Mechanism_1" v-model="Mechanism_1" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="area flex">
                        <span class="width_6"> 荣誉 </span>
                        <input type="text" name="Honor" v-model="Honor"/>
                    </div>
                </div>
                <div>
                    <div class="flex">
                        <div class="area flex">
                            <span> 获得时间 </span>
                            <!-- <input type="text" name="DateTime_2" v-model="DateTime_2" class=" " id="DateTime_2" placeholder="如：2018-06-21" /> -->
                              <el-date-picker
                             v-model="DateTime_2"
                            type="date"
                             value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                            </el-date-picker>
                        </div>
                        <div class="area flex">
                            <span> 颁发机构 </span>
                            <input type="text" name="Mechanism_2" v-model="Mechanism_2" />
                        </div>
                    </div>
                </div>
            </div>

            <span class="btnCookie" @click="nextFn()">保存，继续填写</span>
        </div>
        <div class="content-2 " v-else>
            <div class="fontTitle education">
                3. 工作经历
                <p class="area mTop">以下信息是关于您的工作经历，请您列出最近3年到5年的工作经历和您所负担的职责，主要从事什么业务以及您工作上的成就：</p>
            </div>

            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="area flex">
                        <span class="width_9"> 公司名称 <sup>*</sup> </span>
                        <input type="text" name="CompanyOne" class=" " v-model="CompanyOne" placeholder="最近一次工作公司" />
                    </div>
                </div>
                <div>
                    <div class="flex">
                        <div class="area flex">
                            <span class="width_11"> 时间 <sup>*</sup> </span>
                            <!-- <input type="text" name="ExpDateOne" v-model="ExpDateOne" placeholder="" /> -->
                              <el-date-picker
                              v-model="ExpDateOne"
                            type="monthrange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            value-format="yyyy-MM - yyyy-MM"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div class="area flex">
                            <span class="width_6"> 职位 <sup>*</sup></span>
                            <input type="text"  name="ExpPositionOne" v-model='ExpPositionOne' />
                        </div>
                    </div>
                </div>
            </div>

            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="textareaTitle">工作内容 <sup>*</sup></div>
                    <textarea name="ExpContentOne" v-model="ExpContentOne" placeholder="必填"></textarea>
                </div>

            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="area flex">
                        <span class="width_9"> 公司名称</span>
                        <input type="text" name="CompanyTwo" v-model="CompanyTwo" placeholder="您还在什么地方工作过" />
                    </div>
                </div>
                <div>
                    <div class="flex">
                        <div class="area flex">
                            <span class="width_6"> 时间 </span>
                            <!-- <input type="text" name="ExpDateTwo" v-model="ExpDateTwo" /> -->
                              <el-date-picker
                             v-model="ExpDateTwo"
                            type="monthrange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            value-format="yyyy-MM - yyyy-MM"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div class="area flex">
                            <span class="width_6"> 职位 </span>
                            <input type="text" name="ExpPositionTwo" v-model="ExpPositionTwo" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="textareaTitle">工作内容 </div>
                    <textarea name="ExpContentTwo" class=" " v-model="ExpContentTwo"></textarea>
                </div>
            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="textareaTitle">工作上的成就 <sup>*</sup></div>
                    <input type="text" name="Achievement" v-model="Achievement" class=" " placeholder="说说您在工作上获得过什么成就；如果没有，请填写无" />
                </div>

            </div>
            <!-- 4 -->
            <div class="fontTitle mbottom-1 mtop-3">
                4. 财务信息 <sup>*</sup>
                <p class="area mTop">以下信息是关于您的财务信息，请您根据您的情况状态填写以下信息</p>
            </div>
            <div class="fontTitle mbottom-1 labe">
                <div>
                    <div class="textareaTitle">您家庭的年收入</div>

                    <div class="radios">
                        <input type="radio" id="income1" name="IncomeRadio" v-model="IncomeRadio" value="少于50万">
                        <label for="income1"></label>
                        <span>少于50万</span>
                    </div>
                    <div class="radios">
                        <input type="radio" id="income2" name="IncomeRadio" v-model="IncomeRadio"  value="人民币50万到100万">
                        <label for="income2"></label>
                        <span>人民币50万到100万</span>
                    </div>
                    <div class="radios">
                        <input type="radio" id="income3" name="IncomeRadio" v-model="IncomeRadio"  value="人民币100万到200万">
                        <label for="income3"></label>
                        <span>人民币100万到200万</span>
                    </div>
                    <div class="radios">
                        <input type="radio" id="income4" name="IncomeRadio" v-model="IncomeRadio"  value="人民币200万以上">
                        <label for="income4"></label>
                        <span>人民币200万以上</span>
                    </div>

                </div>

            </div>
            <div class="fontTitle mbottom-1 labe">
                <div>
                    <div class="textareaTitle">个人流动资产(现金/股票）</div>
                    <div class="radios">
                        <input type="radio" id="cash1" name="Cash" v-model="Cash" value="人民币50万到100万">
                        <label for="cash1"></label>
                        <span>人民币50万到100万</span>
                    </div>
                    <div class="radios">
                        <input type="radio" id="cash2" name="Cash" v-model="Cash" value="人民币100万到200万">
                        <label for="cash2"></label>
                        <span>人民币100万到200万</span>
                    </div>
                    <div class="radios">
                        <input type="radio" id="cash3" name="Cash" v-model="Cash" value="人民币300万到500万">
                        <label for="cash3"></label>
                        <span>人民币300万到500万</span>
                    </div>
                    <div class="radios">
                        <input type="radio" id="cash4" name="Cash" v-model="Cash" value="人民币500万以上">
                        <label for="cash4"></label>
                        <span>人民币500万以上</span>
                    </div>
                </div>
            </div>
            <div class="fontTitle flex mbottom-1 labe">
                <div class="shrink">
                    <div class="textareaTitle inlineBlock">其他收入</div>

                    <div class="textareaTitle inlineBlock">
                        <input type="text"  class="width_11 " name="Income" v-model="Income" />
                        万/年
                    </div>
                </div>
                <div>
                    <div class="textareaTitle inlineBlock">个人固定资产</div>
                    <input type="text" class="inlineBlock width_20 " name="Assets" v-model="Assets" placeholder="如房产/车等">
                </div>
            </div>
            <div class="fontTitle cx flex mbottom-1 ">
                <div class="textareaTitle" style="flex-shrink:4.3"> 该工作是否是唯一收入来源 </div>
                <div class="flex">
                    <div class="area flex width_16  cx">
                        <div class="radios">
                            <input type="radio" id="sr1" name="Work" v-model="Work" value="1">
                            <label for="sr1"></label>
                            <span>是</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="sr2" name="Work" v-model="Work" value="0">
                            <label for="sr2"></label>
                            <span>否</span>
                        </div>
                    </div>
                    <div class="area flex">
                        <span class=" textareaTitle width_16" > 是否还有未提到的资产 </span>
                        <input type="text" name="WorkAssets" v-model="WorkAssets" id="inline" placeholder="请填写" />
                    </div>
                </div>
            </div>

            <div class="fontTitle mbottom-1 labe">
                <div class="area mTop textareaTitle flex">
                    <div class="color shrink "> 您是否愿意亲赴七田真中国总部（深圳）进行为期3-6月的实习工作： </div>
                    <div class="shrink" style="margin-top: -2px;">
                        <div class="radios">
                            <input type="radio" id="se1" name="PracticeAnswer" v-model="PracticeAnswer" value="愿意">
                            <label for="se1"></label>
                            <span>愿意</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="se2" name="PracticeAnswer" v-model="PracticeAnswer" value="不愿意">
                            <label for="se2"></label>
                            <span>不愿意</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fontTitle mbottom-1">
                <div>
                    <div class="textareaTitle">您对从事儿童早期教育有什么看法？都了解过哪些品牌？</div>

                </div>
                <!-- <input type="text" name="SituationAnswer" placeholder="请說明" /> -->
                <textarea name="SituationAnswer" v-model="SituationAnswer" placeholder="请說明" class=" "></textarea>
            </div>

            <div class="fontTitle mbottom-1">
                <div>
                    <div class="textareaTitle">您是怎么获悉我司特许经营的招商信息的？</div>

                </div>
                <input type="text" name="ObtainInfo" v-model="ObtainInfo" placeholder="如：广告、互联网、今日头条、朋友推荐" />
            </div>

            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="textareaTitle">
                        您准备在何时
                        <!-- <input type="text" class="width_11" name="SetCenterTime" v-model="SetCenterTime"
                                      placeholder="如：2018-06"> -->
                               <el-date-picker
                            v-model="SetCenterTime"
                            type="month"
                             value-format="yyyy-MM"
                            placeholder="如：2018-06">
                            </el-date-picker> 开设七田真教学中心？
                    </div>
                </div>
            </div>
            <div class="fontTitle mbottom-1 labe">
                <div>
                    <div class="textareaTitle">您申请加入七田真的主要原因：<span class="orange">可多选</span></div>
                    <div class="radios">
                        <input type="checkbox" id="reason2" name="reason2" v-model="ApplyReason1" value="1">
                        <label for="reason2"></label>
                        <span>想拥有自己的事业</span>
                    </div>
                    <div class="radios">
                        <input type="checkbox" id="reason3" name="reason3" v-model="ApplyReason2" value="1">
                        <label for="reason3"></label>
                        <span>热爱婴幼儿早期教育事业</span>
                    </div>
                    <div class="radios">
                        <input type="checkbox" id="reason4" name="reason4" v-model="ApplyReason3" value="1">
                        <label for="reason4"></label>
                        <span>提升企业形象和文化品位，获得社会效益的同时得到经济效益</span>
                    </div>
                    <div class="radios block mTop">
                        <!-- <input type="checkbox" id="reason1" name="reason1" v-model="ApplyReason" value="1"> -->
                        <label for="reason1"></label>
                        <span>其他原因<input class="inpPosition" type="text" name="ApplyReason4" v-model="ApplyReason4" placeholder="请填写原因"></span>
                    </div>

                </div>
            </div>
            <!-- 5 -->
            <div class="fontTitle mbottom-1 mtop-3">
                5. 您认为自己申请加入七田真具有哪些有些方面的优势： <sup>*</sup>
            </div>
            <div class="fontTitle2 cx flex">
                <div class="textareaTitle" style="flex-shrink:4.3"> 独立创业经验: </div>
                <div class="flex">
                    <div class=" area flex width_16 cx" >
                        <div class="radios">
                            <input type="radio" id="confrim-1" v-model='confrim1' name="confrim1" value="1" />
                            <label for="confrim-1"></label>
                            <span>无</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="confrim1" v-model='confrim1' name="confrim1" value="0" />
                            <label for="confrim1"></label>
                            <span>有</span>
                        </div>
                    </div>
                    <div class="area flex">
                        <span class=" textareaTitle width_16"> 如果有 ，请简要描述： </span>
                        <input type="text" name="EntrepreneurialExp" v-model='EntrepreneurialExp' id="confrim_1" placeholder="请填写" />
                    </div>
                </div>
            </div>


            <div class="fontTitle2 cx flex">
                <div class="textareaTitle" style="flex-shrink:4.3"> 经营管理经验：</div>
                <div class="flex">
                    <div class="area flex width_16  cx">
                        <div class="radios">
                            <input type="radio" id="confrim-2" v-model="confrim2" name="confrim2" value="1">
                            <label for="confrim-2"></label>
                            <span>无</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="confrim2" name="confrim2" v-model="confrim2" value="0">
                            <label for="confrim2"></label>
                            <span>有</span>
                        </div>
                    </div>
                    <div class="area flex">
                        <span class=" textareaTitle width_16"> 如果有 ，请简要描述： </span>
                        <input type="text" name="ManagementExp" v-model='ManagementExp' id="confrim_2" class="" placeholder="请填写" />
                    </div>
                </div>
            </div>


            <div class="fontTitle2 cx flex">
                <div class="textareaTitle" style="flex-shrink:4.3"> 从事教育背景：</div>
                <div class="flex">
                    <div class=" area flex width_16 cx" >

                        <div class="radios">
                            <input type="radio" id="confrim-3" name="confrim3" v-model="confrim3" value="1" />
                            <label for="confrim-3"></label>
                            <span>无</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="confrim3" name="confrim3" v-model="confrim3" value="0" />
                            <label for="confrim3"></label>
                            <span>有</span>
                        </div>
                    </div>

                    <div class="area flex">
                        <span class=" textareaTitle width_16"> 如果有 ，请简要描述： </span>
                        <input type="text" name="WorkingEx" v-model="WorkingExp" id="confrim_3" placeholder="请填写" />
                    </div>
                </div>
            </div>

            <div class="fontTitle2 cx flex">
                <div class="textareaTitle" style="flex-shrink:4.3"> 其他相关经验：</div>
                <div class="flex">
                    <div class=" area flex width_16 cx">
                        <div class="radios">
                            <input type="radio" id="confrim-4" name="confrim4" v-model="confrim4" value="1" />
                            <label for="confrim-4"></label>
                            <span>无</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="confrim4" name="confrim4" v-model="confrim4" value="0" />
                            <label for="confrim4"></label>
                            <span>有</span>
                        </div>
                    </div>

                    <div class="area flex">
                        <span class=" textareaTitle width_16"> 如果有 ，请简要描述： </span>
                        <input type="text" name="OtherExp" v-model="OtherExp" id="confrim_4" placeholder="请填写" />
                    </div>
                </div>
            </div>

            <div class="fontTitle2 mbottom-1 mtop-2">
                <div class="mtop-2">
                    <div class="textareaTitle inlineBlock">第一意向城市 &nbsp;&nbsp;</div>
                    <div id="distpicker" class=" inlineBlock">
                        <!-- container -->
                        <select class="select province" v-model="Province1" @change="provinceFn()">
                            <option v-for="(list,i) in ProvinceArr" :key="i" :value="list.Id">{{list.Name}}</option>
                        </select>
                        <select class="select city" v-model="City1" @change="cityFn()">
                            <option v-for="(list,i) in cityArr" :key="i" :value="list.Id">{{list.Name}}</option>
                        </select>
                        <select class="select region" v-model="Region1">
                            <option v-for="(list,i) in RegionArr" :key="i" :value="list.Id">{{list.Name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="fontTitle2 mbottom-1 mtop-2">
                <div class="mtop-2">
                    <div class="textareaTitle inlineBlock">第二意向城市 &nbsp;&nbsp;</div>
                    <div id="distpicker2" class=" inlineBlock">
                        <!-- container -->
                        <select class="select province" v-model="province2"  @change="provinceFn2()" >
                            <option v-for="(list,i) in ProvinceArr" :key="i" :value="list.Id">{{list.Name}}</option>
                        </select>
                        <select class="select city" v-model="city2" @change="cityFn2()">
                            <option v-for="(list,i) in city2Arr" :key="i" :value="list.Id">{{list.Name}}</option>
                        </select>
                        <select class="select region" v-model="region2">
                            <option v-for="(list,i) in Region2Arr" :key="i" :value="list.Id">{{list.Name}}</option>
                        </select>
                    </div>
                    <sub class="orange">选填项</sub>

                </div>
            </div>
            <div class="fontTitle flex mbottom-1">
                <div>
                    <div class="textareaTitle">
                        您目前愿意投资在这个特许项目的资金为
                        <input type="text" class="width_9 " style="text-align:center;" onkeyup="value=value.replace(/[^\d]/g,'')"
                               maxlength="8" v-model="Fund" name="Fund">人民币/万
                    </div>
                </div>
                <div>
                    <div class="textareaTitle">
                        您的资金来源：
                        <div class="radios">
                            <input type="radio" id="from1" name="Source" v-model="Source" value="0">
                            <label for="from1"></label>
                            <span>自有</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="from2" name="Source" v-model="Source" value="1">
                            <label for="from2"></label>
                            <span>合股</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="from3" name="Source" v-model="Source" value="2">
                            <label for="from3"></label>
                            <span>筹借</span>
                        </div>
                        <div class="radios">
                            <input type="radio" id="from4" name="Source" v-model="Source" value="3">
                            <label for="from4"></label>
                            <span>贷款</span>
                        </div>
                    </div>


                </div>
            </div>
            <div class="fontTitle mbottom-1">
                <div>
                    <div class="textareaTitle">当地公共关系（包括与当地政府部门，银行或其他机构的关系：</div>

                </div>
                <input type="text" v-model="PR" name="PR" placeholder="如：教育局关系 , 电视台关系" />
            </div>
            <div class="fontTitle mbottom-1">
                <div>
                    <div class="textareaTitle">家庭成员支持情况：</div>

                </div>
                <input type="text" name="FamilySupport" v-model="FamilySupport" placeholder="如：是否支持您做这份事业" />
            </div>

            <div class="fontTitle mbottom-1">
                <div>
                    <div class="textareaTitle">其他优势：</div>

                </div>
                <input type="text" name="OtherAdvantage" v-model="OtherAdvantage" placeholder="如：有,请填写原因否则填无" />
            </div>
            <!-- 6 -->
            <div class="fontTitle mbottom-1 mtop-3">
                6. 您是独资吗？合伙投资的话，您的合作伙伴的情况是什么？ <sup>*</sup>
                <div style="width:1080px;padding-right:20px;"><textarea name="CooperationSituation" v-model="CooperationSituation" class="mTop"
                                                                        placeholder="请您简单的说说您独资或者与合伙人的情况"></textarea></div>
            </div>
            <!-- <div class="fontTitle mbottom-1">
                <div>
                    <div class="textareaTitle">如果我们能够提供到合作方式是合作预售，即在经营之前先预售我们的课程，如果预售情况良好则开始我们的正式合作，您是否愿意接受：</div>
                </div>
                <input type="text" name="PreSaleSituation" placeholder="请告诉我们您的想法" />
            </div> -->

            <div class="fontTitle mbottom-1">
                <div>
                    <div class="textareaTitle">获得合作人资格以后，是您亲自经营吗？如果不是，您的经营者是谁：</div>
                </div>
                <input type="text" name="OperatingSitu" v-model="OperatingSituation" placeholder="请說明情况" />
            </div>
            <div class="submitBtn"> <span class="prev" @click='prevFn()'>上一页</span><span class="btnCookie" @click="submit()">提交申请</span></div>

        </div>
    </form>
</div>

        <div class="model" v-show="maskBool">
            <div class="panel">
                <img src="https://sk-ims-cabinet.sikegroup.com/image/jpg/tick.png" alt="图片" class="mtop-2">
                <p class="fontTitle mtop"> 提交成功</p>
                <p class="hint ">感谢您关注七田真加盟事业</p>
                <p class="hint" style="margin-top:-6px;">我们将在3个工作日内邮件或电话答复您</p>
                <router-link tag="div" to="/index" class="btnCookie">
                回首页
                </router-link>
            </div>
        </div>
</div>
</template>

<script>

    export default{
        data(){
            return {
                // num:5,
                bool: true,
                maskBool: false,

                ProvinceArr: [],
                Provin: '',//省0
                cityArr: [],//城市11
                RegionArr: [],//地区21
                city2Arr: [],//城市12
                Region2Arr: [],//地区22


                Name: '',
                radioSex:'',
                Marriage:'',//婚姻
                NativePlace: '',//籍贯
                BrithDay: '',
                Mobile:'',
                Tel:'',
                Email: '',
                DateT: '',//联系时间
                HomeAddress: '',
                Address:'',//户籍地
                BringUp:'',//受供养人数

                //配偶
                MateName:'',
                MateProfession: '',//职业
                MatePosition: '',//职务
                MateMobile: '',//手机
                MateEdu: '',//教育
                MateEmail: '',//email
        //教育
                School_1: '',
                GraduationTime_1: '',//毕业时间
                Education:'',//最高学历
                Train:'',//培训经历
                Title:'',//职称
                DateTime_1: '',//获得时间
                DateTime_2: '',
                Mechanism_1: '',//颁发机构
                Mechanism_2: '',
                Honor: '',//荣誉
        // 第二页
                CompanyOne: "",//公司名
                CompanyTwo: '',
                ExpDateOne: '',//时间
                ExpDateTwo: '',
                ExpPositionOne: '',//职位
                ExpPositionTwo: '',
                ExpContentOne: '',//工作内容
                ExpContentTwo: '',
                Achievement: '',//成就
            //财务
                IncomeRadio: '',//年收入
                Cash: '',//流动资产
                Income: '',//其他收入
                Assets: '',//固定资产
                Work: '',//收入来源
                WorkAssets: '',//未提到的资产121
                PracticeAnswer: '',//进行为期3-6月的实习工作
                SituationAnswer:'',//儿童早期教育有什么看法
                ObtainInfo: '',//特许经营的招商信息
                SetCenterTime: '',//开设七田真教学中心？

                // reason: [],//七田真的主要原因：
                ApplyReason4: '',//其他原因
                ApplyReason3: '',
                ApplyReason2: '',
                ApplyReason1: '',

                confrim1: '',//优势
                EntrepreneurialExp: '',//描述
                confrim2: '',//经营管理经验：
                ManagementExp: '',//管理经验描述
                confrim3:'',    //从事教育背景
                WorkingExp: '',//从事教育背景描述
                confrim4: '',//其他相关经验：
                OtherExp: '',//其他相关经验：描述
            //意向城市
                Province1: '省份',
                City1: '城市',
                Region1: '地区',
                province2: '',
                city2: '',
                region2: '',

                Fund:'',//资金
                Source: '',//资金来源
                PR:'',//当地公共关系
                FamilySupport: '',//成员支持情况
                OtherAdvantage: '',//其他优势
                CooperationSituation: '',//独资吗？
                OperatingSituation: '',//h合作人

                infoObj: {},
            }
        },
        created() {
              this.provinFn(0);
        },
        methods:{
            //省0城1区2获取方法
            provinFn(id){
                this.$http.get('https://smart.sikegroup.com/system/city',{params:{id: id}}).then(res =>{
                    this.ProvinceArr=res.data.data;
                })
            },
            //第一页
            nextFn(){

                this.infoObj.Name=this.Name;
                this.infoObj.Sex=this.radioSex;
                this.infoObj.Marriage=this.Marriage;//婚姻
                this.infoObj.NativePlace=this.NativePlace;//籍贯
                this.infoObj.Birthday=this.BrithDay;
                this.infoObj.Mobile=this.Mobile;
                this.infoObj.Tel=this.Tel;
                this.infoObj.Email=this.Email;
                this.infoObj.DateT=this.DateT;//联系时间
                this.infoObj.HomeAddress=this.HomeAddress;
                this.infoObj.Address=this.Address;//户籍地
                this.infoObj.BringUp=this.BringUp;//受供养人数
                //配偶
                this.infoObj.MateName=this.MateName;
                this.infoObj.MateProfession=this.MateProfession;//职业
                this.infoObj.MatePosition=this.MatePosition;//职务
                this.infoObj.MateMobile=this.MateMobile;//手机
                this.infoObj.MateEdu=this.MateEdu;//教育
                this.infoObj.MateEmail=this.MateEmail;//email
                //教育
                let obj={};
                let arr=[];
                obj.School_1=this.School_1;
                try {
                    obj.GraduationTime_1 = this.GraduationTime_1.join(' - ').substring(10, 27);//毕业时间
                }catch(err){  obj.GraduationTime_1= '';}
                obj.Education=this.Education;//最高学历
                obj.Train=this.Train;//培训经历
                obj.Title=this.Title;//职称
                obj.DateTimeOne=this.DateTime_1;//获得时间
                obj.DateTimeTwo=this.DateTime_2;
                obj.MechanismOne=this.Mechanism_1;//颁发机构
                obj.MechanismTwo=this.Mechanism_2;
                obj.Honor=this.Honor;//荣誉
                arr.push(obj);
                this.infoObj.EduBackgroundDetails = JSON.stringify(arr);
                localStorage.setItem('local',JSON.stringify(this.infoObj));
                this.bool = false;
            },
            //上一页
            prevFn(){
                this.bool = true;
            },
            submit(){
                if(!this.CompanyOne||!this.ExpDateOne||!this.ExpPositionOne||!this.ExpContentOne||!this.Achievement){
                    this.$message.error('第三项工作经历未填写完!');
                    return false;
                }

                let ExpDetails={};
                let dateils={}, dateils2={};
                let working=[];
                try{
                    dateils.CompanyOne=this.CompanyOne;
                    dateils.ExpDateOne=this.ExpDateOne.join(' - ').substring(10, 27);
                    dateils.ExpPositionOne=this.ExpPositionOne;
                    dateils.ExpContentOne=this.ExpContentOne;
                }catch(err){
                    dateils = {};
                }

               working.push(dateils);
                try{
                    dateils2.ExpContentOne=this.ExpContentTwo;
                    dateils2.ExpPositionOne=this.ExpPositionTwo;
                    dateils2.CompanyOne=this.CompanyTwo;
                    dateils2.ExpDateOne=this.ExpDateTwo.join(' - ').substring(10, 27);
                 }catch(err){
                    dateils2 = {};
                }
               working.push(dateils2);
               ExpDetails.working=working;
               ExpDetails.Achievement=this.Achievement;
               this.infoObj.ExpDetails=JSON.stringify(ExpDetails);

                if(!this.IncomeRadio||!this.Cash||!this.Income||!this.Assets||!this.Work||!this.PracticeAnswer||!this.SituationAnswer||!this.ObtainInfo||!this.SetCenterTime){
                    this.$message.error('第四项财务信息未填写完!');
                    return false;
                }

                this.infoObj.IncomeRadio=this.IncomeRadio;
                this.infoObj.Cash=this.Cash;
                this.infoObj.Income=this.Income;
                this.infoObj.Assets=this.Assets;
                this.infoObj.Work=this.Work;
                this.infoObj.PracticeAnswer=this.PracticeAnswer;
                this.infoObj.SituationAnswer=this.SituationAnswer;
                this.infoObj.ObtainInfo=this.ObtainInfo;
                this.infoObj.SetCenterTime=this.SetCenterTime;
                this.infoObj.ApplyReason3=this.ApplyReason3;
                this.infoObj.ApplyReason2=this.ApplyReason2;
                this.infoObj.ApplyReason1=this.ApplyReason1;
                this.infoObj.WorkAssets=this.WorkAssets;
                this.infoObj.ApplyReason4=this.ApplyReason4;

                if(!this.confrim1||!this.confrim2||!this.confrim3||!this.confrim4){
                    this.$message.error('第五项加入七田真未填写完!');
                    return false;
                }
                if(this.confrim1==0&&this.EntrepreneurialExp==''){
                    this.$message.error('独立创业经验未填写');
                    return false;
                }
                if(this.confrim2==0&&this.ManagementExp==''){
                    this.$message.error('经营管理经验未填写');
                    return false;
                }
                if(this.confrim3==0&&this.WorkingExp==''){
                    this.$message.error('从事教育背景未填写');
                    return false;
                }
                if(this.confrim4==0&&this.OtherExp==''){
                    this.$message.error('其他相关经验未填写');
                    return false;
                }
                if(!this.EntrepreneurialExp||!this.ManagementExp||!this.WorkingExp||!this.OtherExp){
                    this.$message.error('第五项加入七田真未填写完!');
                    return false;
                }

                this.infoObj.Fund=this.Fund,//资金
                this.infoObj.Source=this.Source;//资金来源
                this.infoObj.PR=this.PR;//当地公共关系
                this.infoObj.FamilySupport=this.FamilySupport;//成员支持情况
                this.infoObj.OtherAdvantage=this.OtherAdvantage;//其他优势
                this.infoObj.ApplyReason4=this.confrim4;
                this.infoObj.ApplyReason3=this.confrim3;
                this.infoObj.ApplyReason2=this.confrim2;
                this.infoObj.ApplyReason1=this.confrim1;
                this.infoObj.EntrepreneurialExp=this.EntrepreneurialExp;
                this.infoObj.ManagementExp=this.ManagementExp;
                this.infoObj.WorkingExp=this.WorkingExp;
                this.infoObj.OtherExp=this.OtherExp;

                if(this.Province1=='省份'||this.City1=='城市'||this.Region1=='地区'){
                    this.$message.error('第一意向城市为必填');
                    return false;
                }
                if(!this.Fund||!this.Source||!this.PR||!this.FamilySupport||!this.OtherAdvantage){
                    this.$message.error('红色*为必填项');
                    return false;
                }

                let proniceCity={};
                let proniceCity2={};
                let cityArr=[];
                proniceCity.Provice=this.Province1;
                proniceCity.City=this.City1;
                proniceCity.Region=this.Region1;
                proniceCity2.Provice=this.province2;
                proniceCity2.City=this.city2;
                proniceCity2.Region=this.region2;
                cityArr.push(proniceCity);
                cityArr.push(proniceCity2);
                this.infoObj.City=JSON.stringify(cityArr);

                if(!this.CooperationSituation||!this.OperatingSituation){
                    this.$message.error('第六项合作人的情况未填写完!');
                    return false;
                }

                this.infoObj.CooperationSituation=this.CooperationSituation;
                this.infoObj.OperatingSituation=this.OperatingSituation;
                  this.$http.post('https://smart.sikegroup.com/v2/Qitianzhen/editPartner',this.infoObj,{emulateJSON:true}).then( res => {
                    if (res.body.code == 1) {
                        this.maskBool = true;
                    } else {

                        if(res.body.msg==this.Mobile){
                            this.$message({type:'error',message:"该号码"+res.body.msg+"录入失败,请直接联系客服！",duration:5000});
                        }else {
                            this.$message({type: 'error', message: '录入失败,请直接联系客服,', duration: 5000});
                        }
                    }
                })
            },

            provinceFn(){
                  this.$http.get('https://smart.sikegroup.com/system/city',{params:{id: this.Province1}}).then(res =>{
                    this.cityArr=res.data.data;
                })
            },
            cityFn(){
                 this.$http.get('https://smart.sikegroup.com/system/city',{params:{id: this.City1}}).then(res =>{
                   this.RegionArr=res.data.data;
                })
            },
            cityFn2(){
                   this.$http.get('https://smart.sikegroup.com/system/city',{params:{id: this.city2}}).then(res =>{
                    this.Region2Arr=res.data.data;
                    })
            },
            provinceFn2(){
                 this.$http.get('https://smart.sikegroup.com/system/city',{params:{id: this.province2}}).then(res =>{
                   this.city2Arr=res.data.data;
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .join-info {
     input,textarea{
         background-color:#fdfcfa;
     }
    select {
        border-radius: 0px !important;
    }

    .green {
        color: #5CB77A !important;
        position: relative;
    }

    .green img {
        position: absolute;
        top: 0px;
        left: 56px;
    }

    .topTab {
        width: 100%;
        height: 50px;
        background-color: #F5F7FA;
        margin-left: 18px;
        justify-content: space-around;
    }

    .topTab span {
        position: absolute;
        top: 14px;
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        border: 1px solid #303133;
        color: #303133;
        font-weight: 400;
        left: 55px;
    }

    .topTab > div {
        line-height: 50px;
        color: #8d8d8d;;
        font-size: 17px;
        font-weight: 300;
        text-align: center;
        position: relative;
    }

    .topTab .img, .topTab img {
        margin-top: 12px;
        height: 24px;
        width: 24px;
        vertical-align: sub;
    }

    .area img {
        margin-top: 10px;
        height: 30px;
        width: 28px;
    }

    /*form表单*/
    sup {
        color: #F5222D;
    }

    .flex {
        display: flex;
        display: -webkit-flex;
    }

    .flex > div {
        width: 100%;
    }

    .width_6 {
        width: 52px !important;
    }

    .width_9 {
        width: 90px !important;
    }

    .width_11 {
        width: 110px !important;
    }

    .width_16 {
        width: 222px !important;
    }

    .width_20 {
        width: 374px !important;
    }

    .shrink {
        flex-shrink: 1.4;
    }

    .minShrink {
        flex-shrink: 1.2;
    }

    .fontTitle {
        font-weight: bold;
        color: #666666;
        font-size: 18px;
    }

    .fontTitle2 {
        color: #666666;
        font-size: 16px;
    }

    .fontTitle > p {
        font-size: 16px;
        color: #8D8D8D;
    }

    .fontTitle > div:nth-child(1) {
        padding-right: 20px;
    }

    .mTop {
        margin-top: 10px !important;
    }

    .minmTop {
        margin-top: 5px;
    }

    .mtop-2 {
        margin-top: 20px;
    }

    .mtop-3 {
        margin-top: 30px;
    }

    .mbottom-1 {
        margin-bottom: 14px;
    }

    .orange {
        font-size: 12px;
        font-family: "Helvetica Neue";
        color: rgba(251, 195, 0, 1);
    }

    .block {
        display: block !important;
        position: relative;
    }

    .inpPosition {
        position: absolute;
        width: 90% !important;
        top: 0px;
        right: 0px;
    }

    .inlne {
        display: inline;
    }

    .inlineBlock {
        display: inline-block;
    }

    .content-2, .content {
        width: 1100px;
        margin: 0px auto;
    }

    .title {
        font-size: 18px;
        height: 60px;
        line-height: 70px;
    }

    .education {
        margin: 30px 0px;
    }

    .minTitle {
        font-size: 16px;
        height: 22px;
        line-height: 26px;
        margin-bottom: 6px;
    }

    .area {
        font-size: 14px;
        font-weight: 500;
        position: relative;
    }

    .flex .area:nth-child(1) {
        margin-right: 24px;
    }


    .area span {
        height: 32px;
        line-height: 30px;
        width: 40%;
        font-size: 14px;
        border-bottom: 1px solid #E0E0E0;

    }

    .lineHeight {
        line-height: 40px !important;
    }

    select, input[type="text"], input[type="email"], input[type="Date"] {
        border: none;
        border-bottom: 1px solid #E0E0E0;
        outline: none;
        height: 32px;
        line-height: 30px;
        font-size: 15px;
        width: 94%;
        color: #7b7b7b;
        font-size: 15px;
    }

    input::-moz-placeholder {
        font-size: 13px;
        color: #CCCCCC;
    }

    input::-webkit-input-placeholder {
        font-size: 13px;
        color: #CCCCCC;
    }

    input::-ms-input-placeholder {
        font-size: 13px;
        color: #CCCCCC;
    }

    select {
        height: 33px;
        line-height: 32px;
        width: 50%;
    }

    .content select {
        /* 隐藏select的下拉图标 */
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        position: relative;
        z-index: 1000;
        background: rgba(0, 0, 0, 0);
    }

    .content select.sel {
        height: 24px;
        line-height: 20px;
        margin-top: 9px;
        width: 50%;
    }

    .color {
        font-weight: 600;
    }

    .area img {
        position: absolute;
        right: 12%;
        top: -14%;
        transform: rotate(90deg);
        width: 20px;
        height: 24px;
        transition: transform 0.4s;
        -moz-transition: transform 0.4s; /* Firefox 4 */
        -webkit-transition: transform 0.4s; /* Safari and Chrome */
        -o-transition: transform 0.4s; /* Opera */
    }

    .content img.icon {
        top: -6%;
    }

    .selectImg {
        transform: rotate(270deg) !important;
        transition: transform 0.4s;
        -moz-transition: transform 0.4s; /* Firefox 4 */
        -webkit-transition: transform 0.4s; /* Safari and Chrome */
        -o-transition: transform 0.4s; /* Opera */
    }

    /* select::after{
       content: '123';
       width: 14px;
       height: 8px;
       background-image: url('https://sk-ims-cabinet.sikegroup.com/image/jpg/right.png');
       /* 通过定位将图标放在合适的位置 */
    /* position: absolute;
    right: 2px;
    top: 4px; */
    /* 给自定义的图标实现点击下来功能 */
    /*  pointer-events: none;
  } */
    /*修改单选框样式*/
    .radios {
        position: relative;
        display: inline;
        margin-top: -6px;
    }

    .radios span {
        border-bottom: 0px solid #FFFFFF;
        font-size: 13px;
        font-weight: 400;
        color: #7b7b7b;
    }

    input[type='checkbox'], input[type='radio'] {
        width: 20px;
        height: 20px;
        opacity: 0;
    }

    .content-2 .radios {
        margin-right: 50px;
    }

    label {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 14px;
        height: 14px;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
    }

    .content-2 label {
        top: 8px;
    }

    .block label {
        margin-top: 2px;
    }
    .labe{
        label{top: 3px;}
    }
    .textareaTitle label {
        top: 3px;
    }

    .content-2 select {
        width: 150px;
        text-align: center;
        height: 30px;
    }

    .textareaTitle .radios {
        margin-right: 20px;
    }

    /*设置选中的input的样式*/
    /* + 是兄弟选择器,获取选中后的label元素*/
    input:checked + label {
        background-color: #5CB77A;
        border: 1px solid #5CB77A;
    }

    input:checked + label::after {
        position: absolute;
        content: "";
        width: 5px;
        height: 10px;
        top: 0px;
        left: 4px;
        border: 2px solid #fff;
        border-top: none;
        border-left: none;
        transform: rotate(45deg)
    }

    /*文本框*/
    .textareaTitle {
        color: #7b7b7b;
        height: 32px;
        line-height: 30px;
        font-size: 15px;
    }

    textarea {
        padding: 6px 10px;
        line-height: 24px;
        min-width: 99.9%;
        max-width: 1057px;
        min-height: 70px;
        border: 1px solid #E0E0E0;
        outline: none;
        font-size: 13px;
        color: #7b7b7b;
    }

    .btnCookie {
        margin: 36px 0px 60px 0px;
        color: #FFFFFF;
        display: inline-block;
        background-color: #FFCC01;
        width: 180px;
        height: 44px;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: 400;
        line-height: 44px;
        text-align: center;
        border-radius: 4px;
        cursor: pointer;
    }

    .submitBtn span {
        border: 1px solid #FFCC01;
        height: 44px;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: 400;
        line-height: 44px;
        width: 130px;
        display: inline-block;

    }

    .prev {
        color: #FFCC01;
        border-radius: 4px;
        margin-right: 30px;
        text-align: center;
    }

    .hidden {
        display: none !important;
    }

    /*model*/

    .model {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 100;
    }

    .model img {
        width: 124px;
        height: 124px;
    }

    .hint {
        color: #7b7b7b;
        height: 30px;
        line-height: 30px;
        font-size: 15px;
        margin-top: 10px;
    }

    .panel {
        background-color: #FFFFFF;
        width: 400px;
        height: 314px;
        border: 4px solid rgba(0, 0, 0, 0.4);
        border-radius: 4px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -157px;
        margin-left: -200px;
        text-align: center;
    }

    .panel .btnCookie {
        width: 70%;
        height: 36px;
        line-height: 36px;
        margin-top: 20px;
    }

    .cx .radios {
        margin-right: 22px !important;
        margin-top: 2px !important;
    }


    /*未正确填写，提示  */
    .border {
        border-color: #FFCC01 !important;
    }

    /*直显示 年月 */

    /* #datepicker .laydate_table {
        display: none;
        }  */
    .laydate_table {
        display: none;
    }

    #laydate_hms {
        display: none !important;
    }
    }
</style>
